"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackedGond = exports.NormGond = exports.TrackedSC = exports.NormSC = exports.TrackedTram = exports.NormTram = exports.TrackedRail = exports.NormRail = exports.TrackedBus = exports.NormBus = exports.LgTrackedShape = exports.LgShape = exports.TrackedShape = exports.Shape = exports.normal = exports.tracked = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _images = require("./images");

var utils = _interopRequireWildcard(require("../../../utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const blue = "#28639c";
const defColor = blue;
const defSelected = "#00bfff";
const tracked = (0, _styledComponents.css)([".rail_blue,.bus_blue{fill:", ";}"], props => props.colorselected || defSelected);
exports.tracked = tracked;
const normal = (0, _styledComponents.css)([".rail_blue,.bus_blue{fill:", ";}background-color:transparent;:hover{.rail_blue,.bus_blue{fill:", ";}}"], props => props.color || defColor, props => props.colorselected || defSelected);
exports.normal = normal;
const Shape = (0, _styledComponents.default)(_images.BusRect).withConfig({
  displayName: "styled__Shape",
  componentId: "b21hpy-0"
})(["", ""], normal);
exports.Shape = Shape;
const TrackedShape = (0, _styledComponents.default)(Shape).withConfig({
  displayName: "styled__TrackedShape",
  componentId: "b21hpy-1"
})(["", ""], tracked);
exports.TrackedShape = TrackedShape;
const LgShape = (0, _styledComponents.default)(_images.RailRect).withConfig({
  displayName: "styled__LgShape",
  componentId: "b21hpy-2"
})(["", ""], normal);
exports.LgShape = LgShape;
const LgTrackedShape = (0, _styledComponents.default)(LgShape).withConfig({
  displayName: "styled__LgTrackedShape",
  componentId: "b21hpy-3"
})(["", ""], tracked);
exports.LgTrackedShape = LgTrackedShape;
const [NormBus, TrackedBus, NormRail, TrackedRail, NormTram, TrackedTram, NormSC, TrackedSC, NormGond, TrackedGond] = utils.makeModeStyles(normal, tracked, _images.Bus, _images.Rail);
exports.TrackedGond = TrackedGond;
exports.NormGond = NormGond;
exports.TrackedSC = TrackedSC;
exports.NormSC = NormSC;
exports.TrackedTram = TrackedTram;
exports.NormTram = NormTram;
exports.TrackedRail = TrackedRail;
exports.NormRail = NormRail;
exports.TrackedBus = TrackedBus;
exports.NormBus = NormBus;
//# sourceMappingURL=styled.js.map